import router from "@/router";
import Home from "@/views/pms/landlord/layout.vue";
import {getAuthMenu} from "@/api/api";
import { BASE_PATH } from "@/config/index.js";

const permission = {
    state: {
        addRouters: [], //过滤后的路由数据
        sideRouter: [], //侧边栏数据
        limitsData: [], //单页权限数据
    },
    getters: {
        // 清空路由
        cleanRouter(state) {
            state.addRouters = [];
            state.sideRouter = [];
        },
        // 返回侧边栏菜单数据
        getSideRouter(state) {
            return state.sideRouter;
        },

        // 返回路由数据
        getAddRouter(state) {
            return state.addRouters;
        },

        // 判断路由是否有数据
        routersLength(state) {
            return state.sideRouter.length;
        },

        // 返回权限数据
        getLimitsData(state) {
            return state.limitsData;
        },
    },
    mutations: {
        // 储存过滤后路由数据
        saveAddRouter(state, data) {
            state.addRouters = data;
        },

        // 储存侧边路由数据
        saveSideRouter(state, data) {
            state.sideRouter = data;
        },

        // 储存权限数据
        saveLimitsData(state, data) {
            state.limitsData = data;
        },
    },
    actions: {
        // 获取路由，动态添加
        loadMenus({commit}) {
            return new Promise((resolve, reject) => {
                getAuthMenu().then((res) => {
                    //接口获取
                    if (res.data.length) {
                        const getRouter = JSON.parse(JSON.stringify(res.data));
                        const rewriteRoutes = routerFilter(getRouter); //将接口获取的数据转换成router组件对象
                        console.log('动态路由：', rewriteRoutes);
                        router.addRoute(rewriteRoutes); // 动态添加可访问路由表
                        
                        // 延迟添加404路由，确保其他路由都已加载完成
                        setTimeout(() => {
                            // 添加404路由作为最后的匹配规则
                            router.addRoute({
                                path: '/:pathMatch(.*)*',
                                meta: {
                                    title: "页面不存在",
                                },
                                component: () => import("@/views/404"),
                            });
                            console.log('添加404路由');
                        }, 100);
                        
                        // 调试：打印当前所有路由
                        setTimeout(() => {
                            console.log('所有路由：', router.getRoutes());
                        }, 200);
                        
                        commit("saveAddRouter", rewriteRoutes);
                        commit("saveSideRouter", getRouter);
                        resolve();
                    } else {
                        reject();
                    }
                });
            });
        },
    },
};
// 其他本地路由
let elseRouter = [
    {
        path: `${BASE_PATH}/landlord/house/details`,
        meta: {
            title: "房间详情",
        },
        component: () => import("@/views/pms/landlord/house/houseDetails"),
    },
    {
        path: `${BASE_PATH}/landlord/room/details`,
        meta: {
            title: "房型详情",
        },
        component: () => import("@/views/pms/landlord/house/roomDetails"),
    },
];
// 将接口获取的数据转换成router组件对象
const routerFilter = (menuData) => {
    let newRouter = {
        path: "/landlord",
        name: "Home",
        component: Home,
        meta: {
            title: "pms",
        },
        children: [],
    };
    let children = [];
    menuData.forEach((itemRouter) => {
        if (itemRouter.child && itemRouter.child.length) {
            itemRouter.child.forEach((itemChild) => {
                let actualPath = itemChild.url;
                // 提取相对路径，例如从/pms/landlord/price/status提取出price/status
                let relativePath = actualPath.replace(/^\/pms\/landlord|^\/pmszs\/landlord/, '');
                // 如果路径以/开头，去掉开头的/
                if (relativePath.startsWith('/')) {
                    relativePath = relativePath.slice(1);
                }
                children.push({
                    path: relativePath,
                    meta: {
                        title: itemChild.title,
                    },
                    component: () => import(`@/views${itemChild.url}`),
                });
            });
        }
    });
    // 添加其他路由
    elseRouter.map((item) => {
        let relativePath = item.path.replace(`${BASE_PATH}/landlord/`, '');
        children.push({
            path: relativePath,
            meta: {
                title: item.meta.title,
            },
            component: item.component
        });
    });
    newRouter.children = children;
    return newRouter;
};
export default permission;